<template>
  <div class="bg-grey">
    <div class="pa-4 display-flex justify-end">
      <img
        src="../../../../assets/mobile/icon/close_circle.svg"
        width="40"
        height="40"
        @click="$emit('previousStep')"
      />
    </div>
    <div class="bg-white pa-4 payment">
      <div class="font-24 font-weight-600 text-black">Loud Pack</div>
      <div>
        <span class="font-20 font-weight-600 text-black">20$/</span>
        <span class="text-poppins-14 font-weight-600 text-black">month</span>
      </div>

      <div class="text-poppins-14 font-weight-600 text-black my-4">
        You have of multiple memberships for this user. You can keep or cancel
        other memberships.
      </div>

      <div class="display-flex justify-space-between mb-2">
        <span class="text-poppins-16 font-weight-600 text-black"> Gold</span>
        <label class="switch">
          <input type="checkbox" />
          <span class="slider round"></span>
        </label>
      </div>

      <div class="display-flex justify-space-between mb-2">
        <span class="text-poppins-16 font-weight-600 text-black">
          Platinum</span
        >
        <label class="switch">
          <input type="checkbox" checked />
          <span class="slider round"></span>
        </label>
      </div>

      <div class="display-flex justify-space-between mb-2">
        <span class="text-poppins-16 font-weight-600 text-black">
          Sample packs
        </span>
        <label class="switch">
          <input type="checkbox" checked />
          <span class="slider round"></span>
        </label>
      </div>

      <v-btn
        class="text-poppins-14 text-white font-weight-700 btn-pay ma-0 full-width my-4"
        @click="$emit('nexStep')"
      >
        <img
          src="../../../../assets/mobile/icon/apple-pay.svg"
          width="58"
          height="24"
        />
      </v-btn>

      <div
        class="text-dmsans-16 text-grey-3 font-weight-400 display-flex align-center full-width mt-2 mb-4"
      >
        <hr class="flex-grow" />
        <span class="mx-2">Or pay with card</span>
        <hr class="flex-grow" />
      </div>

      <div class="text-dmsans-14 font-weight-700 mb-2">Credit card</div>

      <div class="credit-card mb-5">
        <div class="display-flex align-center px-3 credit-card__number">
          <input
            type="text"
            placeholder="1234 1234 1234 1234"
            class="full-width border-none"
          />
          <div class="display-flex align-center gap-8">
            <img
              src="../../../../assets/mobile/icon/visa.svg"
              width="24"
              height="16"
            />
            <img
              src="../../../../assets/mobile/icon/master-card.svg"
              width="24"
              height="16"
            />
            <img
              src="../../../../assets/mobile/icon/american-express.svg"
              width="24"
              height="16"
            />
            <img
              src="../../../../assets/mobile/icon/discover.svg"
              width="24"
              height="16"
            />
          </div>
        </div>
        <div class="display-flex align-center full-width">
          <input
            type="text"
            placeholder="MM / YY"
            class="border-none width-50 credit-card__month px-3 credit-card__month"
          />
          <div class="width-50 px-3 display-flex align-center">
            <input
              type="text"
              placeholder="CVC"
              class="border-none full-width"
            />
            <img
              src="../../../../assets/mobile/icon/card.svg"
              width="24"
              height="16"
            />
          </div>
        </div>
      </div>

      <div class="text-dmsans-14 font-weight-700 mb-2">Country or region</div>

      <div class="mb-4 country-region">
        <v-select
          label="Choose one"
          single-line
          hide-details
          class="pt-0 country"
        ></v-select>
        <div class="zip">
          <input
            type="text"
            placeholder="ZIP"
            class="full-width border-none px-3"
          />
        </div>
      </div>

      <v-btn
        class="text-poppins-18 btn-confirm ma-0 text-white full-width"
        @click="$emit('nexStep')"
      >
        Pay
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "Payment",
};
</script>

<style lang="scss" scoped>
.bg-grey {
  background: rgba(45, 45, 45, 0.93);
}
.payment {
  border-radius: 8px 8px 0 0;
}
.flex-grow {
  flex-grow: 1;
}
.btn-pay {
  border-radius: 4px;
  background: #000 !important;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.08),
    0px 2px 5px 0px rgba(0, 0, 0, 0.12), 0px -1px 1px 0px rgba(0, 0, 0, 0.12);
  height: 48px;
}

.credit-card {
  border-radius: 8px;
  background: #fff;
  border: 1px solid rgba(60, 66, 87, 0.12);
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.04),
    0px 2px 5px 0px rgba(0, 0, 0, 0.08);
  &__number {
    border-bottom: 1px solid rgba(60, 66, 87, 0.12);
  }
  &__month {
    border-right: 1px solid rgba(60, 66, 87, 0.12) !important;
  }
}

.btn-confirm {
  border-radius: 5px;
  background: #0b75ff !important;
  height: 40px;
}

.zip {
  border-top: 1px solid rgba(60, 66, 87, 0.12);
}
.country-region {
  border-radius: 8px;
  border: 1px solid rgba(60, 66, 87, 0.12);
  background: #fff;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.04),
    0px 2px 5px 0px rgba(0, 0, 0, 0.08);
}

.country {
  /deep/.input-group__input {
    border: none !important;
  }
}
/deep/.input-group label {
  top: 0px !important;
}

.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 36px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  background-color: rgba(255, 82, 82, 1);
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  right: 4px;
  background-color: #fff;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: rgba(0, 0, 0, 1);
}

input:checked + .slider:before {
  transform: translateX(16px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// payment.vue?ae7453aa